/**
 * Parcels Details
 */

// React
import React, { useEffect } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import { getFleetAction } from '../actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectFleet,
  makeSelectLoading,
  makeSelectError,
} from '../selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Grid,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiCarMultiple,
  mdiCarKey,
  mdiCarInfo,
  mdiAccountCash,
  mdiTrainCar,
  mdiClipboardAccountOutline,
} from '@mdi/js';

// Helper
import {
  formaterPhoneNumber,
  translate,
} from '../../../utils/helpers';

// Type
import { SelectorProps, Props } from './interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();

  useEffect(() => {
    const id = props.id;
    props?.getFleetWithIdActionDispatch(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCarMultiple} size={1} className={classes.icon} />
              {`نام ناوگان :  `}
            </span>

            <span>{props.fleet.name}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCarKey} size={1} className={classes.icon} />
              {`شناسه ناوگان:  `}
            </span>

            <span>{props.fleet.id}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                style={{ transform: 'scale(-1, 1)' }}
                size={1}
                className={classes.icon}
              />
              {`شماره تماس:  `}
            </span>
            <span>{formaterPhoneNumber(props.fleet.phoneNumber)}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCarInfo} size={1} className={classes.icon} />
              {`نوع ناوگان:  `}
            </span>

            <span>{translate(props.fleet.type, 'fleet')}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountCash}
                size={1}
                className={classes.icon}
              />
              {`نوع تسویه:  `}
            </span>

            <span>{translate(props.fleet.settlementType)}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiTrainCar} size={1} className={classes.icon} />
              {`نوع خودروهای ناوگان:  `}
            </span>
            <span>
              {props.fleet?.vehicleClasses
                ?.map((item: any) => translate(item))
                .join()}
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiAccountOutline} size={1} className={classes.icon} />
              {`نماینده شرکت:  `}
            </span>
            <span>
              <span>
                {props.fleet.agentName}
              </span>
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiClipboardAccountOutline} size={1} className={classes.icon} />
              {`سمت نماینده شرکت:  `}
            </span>
            <span>
              <span>
                {props.fleet.agentPosition}
              </span>
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiPhoneOutline} style={{ transform: 'scale(-1, 1)' }} size={1} className={classes.icon} />
              {`شماره تماس نماینده شرکت:  `}
            </span>
            <span>
              <span>
                {formaterPhoneNumber(props.fleet.agentPhoneNumber)}
              </span>
            </span>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  fleet: makeSelectFleet(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getFleetWithIdActionDispatch: (id: number) =>
      dispatch(getFleetAction({ id })),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
